import StorageTwoToneIcon from "@mui/icons-material/StorageTwoTone";
import AirplayTwoToneIcon from "@mui/icons-material/AirplayTwoTone";
import CloudUploadTwoToneIcon from "@mui/icons-material/CloudUploadTwoTone";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
export default function Header({ backcolor, border }) {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        height: "15%",
        margin: "0",
        background: `${backcolor}`,
        border: `2px solid ${border}`,
        boxShadow: `0 0 15px ${border},inset 0 0 15px ${border}`,
      }}
    >
      <h1
        style={{
          width: "80%",
          color: `white`,
          padding: "20px",
          display: "flex",
           alignItems:"center",
           gap:"20%"
        }}
        align="left"
      >
        Air Tracker
         <p style={{color:"white"}}>the Data is Updatewd every 50 seconds</p>
      </h1>
     
      <div
        className="icon"
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "20%",
          padding: "30px",
          color: "white",
        }}
      >
        <div>
          <CloudUploadTwoToneIcon
            fontSize="large"
            style={{ color: `#00e5ff` }}
          ></CloudUploadTwoToneIcon>
          <p style={{ color: `white` }}>OpenSky API</p>
        </div>
        <ArrowForwardIcon
          fontSize="large"
          style={{ color: `#00e5ff` }}
        ></ArrowForwardIcon>
        <div>
          <StorageTwoToneIcon
            fontSize="large"
            style={{ color: `#00e5ff` }}
          ></StorageTwoToneIcon>
          <p style={{ color: `white` }}>Backe-End</p>
        </div>

        <ArrowForwardIcon
          fontSize="large"
          style={{ color: `#00e5ff` }}
        ></ArrowForwardIcon>
        <div>
          <AirplayTwoToneIcon
            fontSize="large"
            style={{ color: `#00e5ff` }}
          ></AirplayTwoToneIcon>
          <p style={{ color: `white` }}>Front-End</p>
        </div>
      </div>
    </div>
  );
}
